import { PRIORITY_VALUE_NAME_MAP, PRIORITY_VALUE_VARIANT_MAP } from "./constants.js";
import "react";
import { Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdWarningAmber } from "react-icons/md";
//#region src/components/Priority/Priority.tsx
function Priority({ priority }) {
	if (!priority) return null;
	return /* @__PURE__ */ jsxs("span", {
		className: `bg-${PRIORITY_VALUE_VARIANT_MAP[priority]} space-x-xxs px-xs text-color-semantic flex items-center rounded text-sm`,
		children: [
			/* @__PURE__ */ jsx(Icon, {
				Icon: MdWarningAmber,
				size: "sm"
			}),
			/* @__PURE__ */ jsx("span", { children: PRIORITY_VALUE_NAME_MAP[priority] }),
			/* @__PURE__ */ jsx("span", { children: "Priority" })
		]
	});
}
//#endregion
export { Priority };

//# sourceMappingURL=Priority.js.map